<template>
  <b-container>
    <b-row>
      <b-col>
        <transition-group class="task-level-list">
          <b-link
            :class="{
              'test-card': true,
              locked: !negLevel.is_open,
              'test-one': index === 7,
              'test-two': index === 15,
              'test-three': index === 23,
              'card-second': index > 7,
              'card-third': index > 15,
            }"
            :disabled="!negLevel.is_open"
            :to="{
              name: negLevel.isLevel ? 'Task' : 'Test',
              params: { lid: negLevel.order },
            }"
            v-for="(negLevel, index) in levels"
            :key="
              negLevel != null
                ? negLevel.id * 1000 + index
                : Math.trunc(Math.random() * 100000)
            "
          >
            <div class="task-number" v-if="negLevel.isLevel">
              {{ negLevel.order }}
            </div>
            <div
              class="test-title"
              :class="{
                test1: index == 7,
                test2: index == 15,
                test3: index == 23,
              }"
              v-if="!negLevel.isLevel"
            >
              Сорил
            </div>

            <div class="lock">
              <img src="../assets/images/lock.png" width="30px" />
            </div>

            <div class="star-container">
              <div v-for="(i, index) in 3" :key="index">
                <b-icon
                  :class="{
                    one: negLevel.rating === 1 && index === 0,
                    two: negLevel.rating === 2 && index < 2,
                    three: negLevel.rating === 3 && index < 3,
                  }"
                  icon="star-fill"
                ></b-icon>
              </div>
            </div>
          </b-link>
        </transition-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  props: ["levels"],
  data() {
    return {
      choice: ["Task", "Test"],
      starColor: "#FF3D00",
    };
  },

  mounted() {
    if (!localStorage.getItem("category")) {
      this.category = this.$route.params.cid;
      localStorage.setItem("category", this.category);
    } else {
      if (this.$route.params.cid !== undefined) {
        this.category = this.$route.params.cid;
        localStorage.setItem("category", this.category);
      } else {
        this.category = localStorage.getItem("category");
      }
    }
  },
};
</script>

<style lang="postcss" scoped>
.task-content-start {
  position: relative;
  padding: 0px 50px 10px 50px;
}
.task-level-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  grid-gap: 20px;
}
.task-level-list:hover {
  text-decoration: none;
}

.task-number {
  font-size: 2.6em;
  color: #fff;
  font-weight: bold;
  text-align: start;
  padding-left: 10px;
}
.test-number {
  font-size: 1em;
}
.score {
  color: #8395a7;
}

.list-score-count {
  font-size: 1.9375em;
  font-family: roboto;
  color: #ffffff;
  padding-bottom: 35px;
}

/*router test*/
.test-card {
  background-color: #f18719;
  border-radius: 40px;
  border: 5px solid #ffffff;
  cursor: pointer;
  position: relative;
  text-decoration: none;
  align-items: center;
  overflow: hidden;
}

.test-card:after {
  content: "";
  display: block;
  padding-bottom: 60%;
}

.test-card:hover,
.test-card:focus {
  animation: mouseOver 0.2s alternate forwards;
}

@keyframes mouseOver {
  0% {
    top: 0;
  }
  100% {
    top: -5px;
    box-shadow: 0 3px 10px #853;
  }
}

.test1 {
  color: #f18719;
}
.test2 {
  color: #69b644;
}
.test3 {
  color: #26a3db;
}
.card-second {
  background-color: #69b644;
}
.card-third {
  background-color: #26a3db;
}
.test-one {
  background-color: #ff8200;
}
.test-two {
  background-color: #22b353;
}
.test-three {
  background-color: #0085c1;
}
.test-card.locked {
  background-color: gainsboro;
}
.test-title {
  text-align: center;
  font-size: 1.2em;
  background-color: #fff;
  border-radius: 30px;
  padding: 5px;
  margin-bottom: 24px;
}

.star-container {
  width: 100%;
  padding: 0px 10px 0px 10px;
  font-size: 1.6em;
  display: flex;
  justify-content: space-around;
  border-radius: 30px;
  background: #fff;
  stroke: #a1a1a1;
  color: white;
  position: absolute;
  bottom: 0;
}

.one {
  color: red;
}
.two {
  color: red;
}
.three {
  color: red;
}
.lock {
  text-align: center;
  visibility: hidden;
}
.test-card.locked .lock {
  visibility: visible;
}
</style>
